/**
 * Extract a usable message from auth API errors (string, JSON string, or object body).
 */
export const parseAuthApiErrorMessage = (error) => {
  const rawData = error?.response?.data;
  let status = error?.response?.status;
  let message = "";

  if (typeof rawData === "string") {
    try {
      const parsed = JSON.parse(rawData);
      message = parsed?.message || rawData.trim();
      status = parsed?.status || status;
    } catch {
      message = rawData.trim();
    }
  } else if (typeof rawData === "object" && rawData !== null) {
    message = rawData?.message || "";
    status = rawData?.status || status;
  }

  if (!message && error?.message) {
    message = error.message;
  }

  return { message, status };
};

export const isRateLimitMessage = (status, message = "") => {
  const lower = String(message).toLowerCase();
  return (
    status === 429 ||
    lower.includes("too many") ||
    lower.includes("rate limit")
  );
};

const RATE_LIMIT_FALLBACK =
  "Too many attempts. Please wait 15 minutes and try again.";

/**
 * Resolve the user-facing auth error message. Prefer server text; never drop it.
 */
export const getAuthErrorMessage = (
  error,
  {
    fallback = "Something went wrong. Please try again.",
    rateLimitFallback = RATE_LIMIT_FALLBACK,
  } = {}
) => {
  const { message, status } = parseAuthApiErrorMessage(error);

  if (isRateLimitMessage(status, message)) {
    return message || rateLimitFallback;
  }

  return message || fallback;
};
